export default {
    namespaced: true,
    state: {
        name_section: null
    },
    mutations: {
        set_name_section (state, value) {
            state.name_section = value;
        }
    },
    actions: {
        setNameSection({commit}, value) {
            commit('set_name_section', value);
        }
    }
}